const initLookbook = () => {
  const sections = document.querySelectorAll(".section-lookbook");
  if (sections.length === 0 || !sections) return;

  const initLookbookSectionFunctionality = (section) => {
    const mobileTriggers = section.querySelectorAll(".hotspot-mobile-trigger");
    if (!mobileTriggers || mobileTriggers.length === 0) return;

    mobileTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleMobileTriggerClick(section, mobileTriggers));
    });
  };

  const handleMobileTriggerClick = (section, mobileTriggers) => (clickEvent) => {
    if (clickEvent.target.getAttribute("aria-selected") === "true") {
    return;
    } else {
      clickEvent.preventDefault();
    }
    mobileTriggers.forEach((trigger) => trigger.setAttribute("aria-selected", "false"));
    section.querySelector('.hotspot-mobile--active')?.classList.remove('hotspot-mobile--active');
    section.querySelector('.hotspot-mobile--active')?.setAttribute('tabindex', '0');

    const controlledElementId = clickEvent.target.getAttribute("aria-controls");
    const controlledElement = section
    .querySelector(`#${controlledElementId}`);

    if (!controlledElement) return;
    
    controlledElement?.classList.add("hotspot-mobile--active");
    controlledElement?.setAttribute('tabIndex', '1');
      clickEvent.target.setAttribute("aria-selected", "true");
    section.querySelector('.mobile-hotspots-container')?.style.setProperty("--container-height", `${controlledElement.getBoundingClientRect().height}px`);
  };

  sections.forEach((section) => initLookbookSectionFunctionality(section));
};

document.addEventListener("DOMContentLoaded", () => {
  initLookbook();
});
